@if (visible()) {
  <div
    class="fixed inset-x-0 bottom-0 z-[1000] px-3 pointer-events-none"
    style="padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 0.75rem)"
    role="region"
    aria-label="Install Pharvios">
    <div
      class="pointer-events-auto mx-auto max-w-md card p-3 border border-divider shadow-lg">
      <div class="w-full flex justify-end items-end">
        <button
          mat-icon-button
          type="button"
          aria-label="Dismiss install prompt"
          (click)="dismiss()">
          <mat-icon svgIcon="mat:close"></mat-icon>
        </button>
      </div>
      <div class="w-full flex items-center gap-3">
        <span
          class="flex items-center justify-center w-10 h-10 shrink-0 rounded-full bg-primary-600/10 text-primary-600">
          <mat-icon svgIcon="mat:install_mobile"></mat-icon>
        </span>
        <div class="flex-1 min-w-0">
          <p class="text-base font-semibold text-default m-0 py-0.5">
            Install Pharvios
          </p>
          <p class="text-sm text-secondary m-0 pt-0.5 pb-2">
            Get faster access and seamless offline support.
          </p>
          <div class="w-full flex justify-end items-center">
            <button
              mat-flat-button
              color="primary"
              type="button"
              (click)="install()">
              <span class="p-1">
                {{ actionLabel() }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
